import { makeStyles } from '@map/theme';
import { useIntlToString, type IntlToStringable } from '@shared/hooks/intl';
import Button from '@ui/Button';
import { ReactElement } from 'react';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    '&:hover': {
      backgroundColor: palette.primary[100],
      borderColor: palette.primary[500],
    },
    '&.Diia': {
      border: 'none',
    },
  },
}));

type Props = {
  icon: ReactElement;
  label: IntlToStringable | string;
  onClick: () => void;
  provider?: string;
};
const SocialCircleButton = ({ icon, label, onClick, provider }: Props) => {
  const { classes, cx } = useStyles();
  const intlToString = useIntlToString();
  const ariaLabel = typeof label === 'string' ? label : intlToString(label);
  return (
    <Button
      icon={true}
      size="medium"
      variant="secondary"
      className={cx(classes.root, provider)}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {icon}
    </Button>
  );
};

export default SocialCircleButton;
